import React, { type ReactNode } from 'react'
import { Switch, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type ISettingsCardProps = {
  title: ReactNode
  desc: ReactNode
  value: boolean
  setValue: (value: boolean) => void
}

export const SettingsCard = ({ title, desc, value, setValue }: ISettingsCardProps) => (
  <div className={styles.card}>
    <div className={styles.left}>
      <Typography ariaLabel={'title'} variant={'body-md-medium'}>
        {title}
      </Typography>
      <Typography ariaLabel={'desc'} variant={'body-md-regular'} color={'tertiary'}>
        {desc}
      </Typography>
    </div>
    <div className={styles.right}>
      <Switch value={value} onChange={setValue} />
    </div>
  </div>
)
